import { useContext } from 'react';

import { matchPath, NavLink, useLocation } from 'react-router-dom';

import { classNames } from 'src/common/classNames';

import { TopLevelNavItemContext } from './TopLevelNavItemContext';

export function DesktopNavLinkList() {
  const navigation = useContext(TopLevelNavItemContext);
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <div className="flex space-x-2">
      {navigation.map((item) => (
        <NavLink
          key={item.name}
          to={item.href}
          className={(isActive) =>
            classNames(
              matchPath({ path: item.href, end: false }, currentPath)
                ? 'bg-mint-light text-indigo'
                : 'text-gray-700 hover:bg-mint-light hover:text-indigo',
              'rounded-md px-3 py-2 text-sm font-medium'
            )
          }
          aria-current={
            matchPath({ path: item.href, end: false }, currentPath)
              ? 'page'
              : undefined
          }
        >
          {item.name}
        </NavLink>
      ))}
    </div>
  );
}
